module.exports = __webpack_public_path__ + "static/img/AZ.0f3eaed1.png";